import React, { useMemo } from 'react';

import ProtectedData from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    label: string;
    className?: string;
}
const Tag: React.FC<Props> = ({ label, className }) => {
    const { classes, cx } = useStyles();
    const href = useMemo(() => `/search?query=enchantments.tags:${encodeURIComponent(`"${label}"`)}`, [label]);

    return (
        <a
            className={cx(classes.root, className)}
            href={href}
            target="_blank"
            rel="noreferrer"
            onClick={(event) => event.stopPropagation()}
        >
            <ProtectedData data={label} />
        </a>
    );
};

export default Tag;
